module.exports = __webpack_public_path__ + "img/call_me.67d7b277.png";